/**
 * Clone Legal Case
 */
import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const CloneLegalCaseState = {
  cloneLegalCase: {
    legalCaseId: null,
    legalCaseName: null,
    legalCaseRecords: [],
    showDialog: false,
  },
}

export const CloneLegalCaseActions = {
  cloneLegalCaseToRecord: async (_, requestData) => {
    return axiosRequest.
      post(`/legal_cases/${requestData.id}/clone`, { legal_case: { record_ids: requestData.recordIds } }).
      then(({ data }) => data).
      catch(handleError)
  },

  getLegalCaseRecords: async ({ commit }, requestData) => {
    commit('setSearchLoading', true)

    return axiosRequest.
      get('/records', { params: requestData.params }).
      then(({ data }) => {
        commit('setLegalCaseId', requestData.id)
        commit('setLegalCaseRecords', data.records || {})
        commit('setSearchLoading', false)
      }).
      catch(handleError)
  },
}

export const CloneLegalCaseMutations = {
  setDuplicateLegalCase: (state, payload) => {
    state.cloneLegalCase.legalCaseId = payload.legalCaseId
    state.cloneLegalCase.legalCaseName = payload.legalCaseName
    state.cloneLegalCase.showDialog = payload.showDialog
  },

  setLegalCaseRecords: (state, value) => {
    state.cloneLegalCase.legalCaseRecords = value
  },
}

export const CloneLegalCaseGetters = {
  legalCaseName: state => state.cloneLegalCase.legalCaseName,
  legalCaseTitle: state => `${state.cloneLegalCase.legalCaseName?.fullName} (Case ID: ${state.cloneLegalCase.legalCaseId})`,
  isLoading: state => state.isSearching,
  legalCaseId: state => state.cloneLegalCase.legalCaseId,
  legalCaseRecords: state => state.cloneLegalCase.legalCaseRecords,
  paginationOptions: state => state.paginationOptions,
  showDialog: state => state.cloneLegalCase.showDialog,
}
